// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision.shape

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * A box, centered around the origin
 *
 * C++ `JPH::BoxShape`.
 */
class BoxShape internal constructor(internal val boxShapeHandle: NativePointer, owned: Boolean = false) : ConvexShape(JphBoxShape_asConvexShape(boxShapeHandle), owned), AutoCloseable {
    constructor() : this(JphBoxShape_create(), owned = true)
    constructor(halfExtent: Vec3, convexRadius: Float, material: PhysicsMaterial?) : this(interopScope { JphBoxShape_create_Vec3Arg_float_PhysicsMaterial(toInterop(halfExtent.toArray()), convexRadius, material?.physicsMaterialHandle ?: NullPointer) }, owned = true)

    override fun addRef() =
        own { JphBoxShape_addRef(boxShapeHandle) }

    override fun close() =
        closeOnce { JphBoxShape_release(boxShapeHandle) }

    /** Get half extent of box */
    val halfExtent: Vec3
        get() = interopScope {
            val returned = FloatArray(4)
            val returnedPointer = toInterop(returned)
            JphBoxShape_GetHalfExtent(boxShapeHandle, returnedPointer)
            returnedPointer.fromInterop(returned)
            Vec3(returned)
        }

    /** Get the convex radius of this box */
    val convexRadius: Float
        get() = JphBoxShape_GetConvexRadius(boxShapeHandle)
}
